import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { JSX } from "react";

interface RoleRouteProps {
  children: JSX.Element;
  allowedRole: "Admin" | "Coordinator";
}

const RoleRoute = ({ children, allowedRole }: RoleRouteProps) => {
  const { role } = useAuth();

  if (!role) {
    return <Navigate to="/login" replace />;
  }

  if (role !== allowedRole) {
    // Redirect to correct dashboard
    if (role === "Admin") return <Navigate to="/admin" replace />;
    if (role === "Coordinator") return <Navigate to="/coordinator" replace />;
  }

  return children;
};

export default RoleRoute;